import type {
  CSSProperties,
  ReactNode,
} from 'react'

import {
  ContextualMenu,
} from './ContextualMenu'

import {
  useContextualSettings,
} from './ContextualSettingsContext'

interface Props {
  id: string
  title: string

  children: ReactNode
  menuExtra?: ReactNode

  allowHide?: boolean
  showMenu?: boolean
  className?: string
}

export function ContextualSurface({
  id,
  title,
  children,
  menuExtra,
  allowHide = true,
  showMenu = true,
  className = '',
}: Props) {
  const {
    get,
  } =
    useContextualSettings()

  const settings =
    get(id)

  if (!settings.visible) {
    return null
  }

  const style = {
    '--r7-local-text-scale':
      String(
        settings.textScale,
      ),

    '--r7-local-text-color':
      settings.textColor ??
      'inherit',

    '--r7-local-background':
      settings.backgroundColor ??
      'transparent',
  } as CSSProperties

  return (
    <div
      className={
        `r7-context-surface ${className}`
      }
      style={style}
    >
      {showMenu && (
        <div className="r7-context-slot">
          <ContextualMenu
            id={id}
            title={title}
            allowHide={allowHide}
          >
            {menuExtra}
          </ContextualMenu>
        </div>
      )}

      {children}
    </div>
  )
}
